import { render } from "./BbResult.vue?vue&type=template&id=083644ae&scoped=true"
import script from "./BbResult.vue?vue&type=script&lang=js"
export * from "./BbResult.vue?vue&type=script&lang=js"

import "./BbResult.vue?vue&type=style&index=0&id=083644ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083644ae"]])

export default __exports__